import { render, staticRenderFns } from "./StudentCourseOverview.vue?vue&type=template&id=7961b9f4&"
import script from "./StudentCourseOverview.vue?vue&type=script&lang=js&"
export * from "./StudentCourseOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports